 <table *ngIf="groupResults && groupResults.length>0" class="display my-table table-bordered " attr.style="margin-right:1%; float:left; width:{{period.tableWidth}}%;">
                <thead>
                    <tr style="height: 10px;" attr.style="font-size:{{period.headTableTextsize}}px">
                        <th *ngIf="period.showId">#</th>
                        <th>{{period?.tmat}}</th>
                        <th>{{ period?.tcoef }}</th>
                        <th *ngFor="let ps of period?.periods">
                            {{ ps.code}}
                        </th>
                        <th>{{ period?.tmg}}</th>
                        <th *ngIf="period.tools">Calculable</th>
                    </tr>
                </thead>
                <tbody *ngFor="let g of groupResults; let j = index" >
                   <tr  attr.style="height: auto; padding:none; font-size:{{period.text_cat }}px;">
                        <td *ngIf="period.showId">
                            {{ g?.code}}
                        </td>
                        <td>
                           <b> {{ g?.categorie?.name}}</b>
                        </td>
                        <td class="note-td">
                            {{ g?.categorie?.note_total }}
                        </td>
                        <td class="note-td" *ngFor="let nt of g.list_note">

                        </td>
                        <td class="note-td">

                        </td>
                        <td class="note-td" *ngIf="!g.is_calc">-</td>
                        <td class="note-td" *ngIf="period.tools">
                            <input type="checkbox" [(ngModel)]="g.is_calc">
                        </td>
                    </tr>
                    <tr *ngFor="let o of g.results ; let i = index" attr.style="height: auto; padding:none; font-size:{{period.text_cours}}px;">
                        <td *ngIf="period.showId">
                            {{ o?.cours?.code}}
                        </td>
                        <td>
                            {{ o?.cours?.name}}
                        </td>
                        <td class="note-td">
                            {{ o?.cours?.note_total }}
                        </td>
                        <td class="note-td" *ngFor="let nt of o.note">
                            {{ nt }}
                        </td>
                        <td class="note-td">
                            {{ o?.note_total?.toFixed(2) }}
                        </td>
                        <td class="note-td" *ngIf="!o.is_calc">-</td>
                        <td class="note-td" *ngIf="period.tools">
                            <input type="checkbox" [(ngModel)]="o.is_calc">
                        </td>
                    </tr>

                     <tr  attr.style="height: auto; padding:none; font-size:{{period.text_cat }}px;">
                        <td *ngIf="period.showId">

                        </td>
                        <td>

                        </td>
                        <td class="note-td">

                        </td>
                        <td class="note-td" *ngFor="let nt of g.list_note; let i = index ">
                               <b *ngIf="(g.list_note.length-1)==i" > Total</b>
                        </td>
                        <td class="note-td">
                                 {{ g.note }}  / <b> {{ g?.categorie?.note_total }}  </b>
                        </td>
                        <td class="note-td" *ngIf="!g.is_calc">-</td>
                        <td class="note-td" *ngIf="period.tools">
                            <input type="checkbox" [(ngModel)]="g.is_calc">
                        </td>
                    </tr>
                </tbody>
                <tbody  >
                    <tr attr.style="height: auto; padding:none; font-size:{{period.text_cours}}px;">
                        <td *ngIf="period.showId">
                          <b>
                           </b>
                        </td>
                        <td><b>Total</b></td>
                        <td class="note-td" *ngIf="!period.tools">{{ bulletin.coef }}</td>
                        <td class="note-td" *ngIf="period.tools">
                            <input type="number" [(ngModel)]="bulletin.coef" style="width:100%;" class="form-control">
                        </td>
                        <td class="note-td" *ngFor="let ntg of bulletin.total_note_period">
                            <b>{{ntg}}</b>
                        </td>
                        <td class="note-td"> <b> {{ (bulletin?.total_note) ? (bulletin?.total_note?.toFixed(2) / period.periods.length).toFixed(2)  : '0' }}</b></td>

                    </tr>
                    <tr attr.style="height: auto; padding:none; font-size:{{period.text_cours}}px;">
                        <td *ngIf="period.showId"></td>
                        <td><b>Moyenne de l'élève</b></td>
                        <td class="note-td">
                            <b>{{period?.etab?.moy_total}}</b>
                        </td>
                        <td class="note-td" *ngFor="let ntg of bulletin.total_note_period">
                            <b>
                               {{((ntg/bulletin.coef) * period?.etab?.moy_total).toFixed(2)}}
                            </b>
                        </td>
                        <td class="note-td">
                            <b>{{ ((((bulletin?.total_note?.toFixed(2) / period.periods.length)) / bulletin.coef) * period?.etab?.moy_total).toFixed(2) }}</b>
                        </td>
                        <td *ngIf="tools"></td>
                    </tr>
                    <tr attr.style="height: auto; padding:none; font-size:{{period.text_cours}}px;">
                        <td *ngIf="period.showId"></td>
                        <td><b>Moyenne de la classe</b></td>
                        <td class="note-td">
                            <b>{{period?.etab?.moy_total}}</b>
                        </td>
                        <td class="note-td" *ngFor="let mtp of period.periods">
                            <b> {{ mtp?.moy_classe?.toFixed(2)}}    </b>
                        </td>
                        <td class="note-td">
                            <b>{{ period?.moy_classe_gen.toFixed(2) }}</b> </td>
                        <td *ngIf="tools"></td>
                    </tr>
                </tbody>
 </table>
